import { useTranslation } from "next-i18next"

const usePartsDiagram = () => {
  const { t } = useTranslation()
  const i18n = {
    printDiagrams: t("kf.myList.parts.partviewer.printDiagrams"),
    printAllText: t("kf.myList.parts.partviewer.printAllText"),
    printSelectedText: t("kf.myList.parts.partviewer.printSelectedText"),
    errorSorryText: t("kf.error.parts.partviewer.sorryErrorText"),
    errorTextTwo: t("kf.error.parts.partviewer.anyText"),
    errorContactText: t("kf.error.parts.partviewer.contact"),
    totalCountText: t("kf.plp.label.results"),
    loadMore: t("kf.plp.label.loadMore"),
    backToTop: t("kf.plp.label.backToTop"),
    expandText: t("kf.myList.parts.partviewer.expand"),
    exitExpandText: t("kf.myList.parts.partviewer.exitExpand"),
    listPriceText: t("kf.list.table.listPrice"),
    gridViewText: t("kf.plp.label.gridView"),
    listViewText: t("kf.myList.parts.partviewer.listViewText"),
    sortByText: t("kf.plp.label.sort"),
    sortText: t("kf.plp.label.img.altSort"),
    exitFullScreenText: t("kf.myList.partViewer.exitFullScreenText"),
    fullScreenText: t("kf.myList.partViewer.fullScreenText"),
    coachMarkText: t("kf.myList.partViewer.coachMark"),
    listPriceDescText: t("kf.pdp.label.listPriceInfo"),
    colorFinish: t("kf.pdp.label.colorOrFinish"),
    parts: t("kf.search.label.parts"),
    diagramText: t("kf.myList.partViewer.diagramText"),
  }

  return i18n
}

export default usePartsDiagram
